<template>
  <el-form class="header-info detail-page" label-width="auto">
    <ZlDetail border :data="data" :row="{ gutter: 20 }" :options="detail._group.group" @show-tip="showTip" @hide-tip="hideTip" />
    <el-tooltip ref="tooltip" placement="top-start" :effect="tooltipEffect" :content="tooltipContent" />
  </el-form>
</template>

<script>
import ZlDetail from '@utils/detail/components/detail-page-list'
import Detail from '@utils/detail'
import debounce from 'throttle-debounce/debounce'
export default {
  components: {
    ZlDetail
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tooltipEffect: 'dark',
      tooltipContent: ''
    }
  },
  computed: {
    roundsList() {
      return this.data.roundsList || []
    },
    detail() {
      const detail = new Detail('bidmanagementpur.biddingmonitoring')
        .setSpan(6)
        .add('biddingNo')
        .add('projectBudget')
        .add('signUpDeadline')
        .add('planSignDate')

      return detail
    }
  },
  created() {
    this.activateTooltip = debounce(50, tooltip => tooltip.handleShowPopper())
  },
  methods: {
    showTip(cell) {
      const tooltip = this.$refs.tooltip
      this.tooltipContent = cell.innerText || cell.textContent
      tooltip.referenceElm = cell
      tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none')
      tooltip.doDestroy()
      tooltip.setExpectedState(true)
      this.activateTooltip(tooltip)
    },
    hideTip() {
      const tooltip = this.$refs.tooltip
      if (tooltip) {
        tooltip.setExpectedState(false)
        tooltip.handleClosePopper()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-info {
  padding: 0 25px;
  padding-top: 15px;
}
</style>
